// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16_hw","productName":"Table_productName__3kd3X"};